module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-handan.be95056e.png";